<template>
  <div id="add-user">
    <!-- 添加学员组件 -->
    <div class="left">
      <div class="top">
        <el-input v-model="search" placeholder="可输入学员姓名搜索"></el-input>
      </div>
      <div class="table">
        <el-table :data="userAllList" border style="width: 100%" height="600">
          <el-table-column type="index" label="序号" width="55">
          </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row, '1')"
                >选择</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="left">
      <div class="top">已选择通讯录学员:</div>
      <div class="table">
        <el-table :data="data" border style="width: 100%" height="600">
          <el-table-column type="index" label="序号" width="55">
          </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row, '0')"
                >取消</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "diy_dialog_add_user",
  props: {
    userAllList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    userData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      data: this.userData,
      search: "",
    };
  },
  watch: {
    userData() {
      this.data = this.userData;
    },
    data(newValue) {
      this.$emit("showAddUser", this.data);
    },
  },
  methods: {
    handleEdit(index, data, flag) {
      switch (flag) {
        case "1":
          // 选择学员

          let array = this.data;
          array.push(JSON.parse(JSON.stringify(data)));
          let set = new Set(array.map(JSON.stringify));
          this.data = Array.from(set).map(JSON.parse);

          // this.data.push(JSON.parse(JSON.stringify(data)));
          break;
        case "0":
          // 取消学员
          this.data.splice(index, 1);
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
#add-user {
  width: 100%;
  height: auto;
  max-height: 800px;
  display: flex;
  > .left {
    width: 0;
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    > .top {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      color: #b9b9b9;
    }
    > .table {
      width: 100%;
      height: 0;
      flex: 1;
      display: flex;
    }
  }
}
</style>         